/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { PageTitle } from '../../../_metronic/layout/core'
import {
  ChartsWidget1,
  ChartsWidget2,
  ChartsWidget6,
  ListsWidget4,
  ListsWidget2,
  ListsWidget6,
  StatisticsWidget5,
  StatisticsWidget6,
  TablesWidget10,
  TablesWidget13,
  TablesWidget9,
  ChartsWidget3
} from '../../../_metronic/partials/widgets'
import StatsCard from './StatsCard'

import { ChartsWidget2Copy } from '../../../_metronic/partials/widgets/charts/ChartsWidget2Copy'
import { ChartsWidget2Recycler } from '../../../_metronic/partials/widgets/charts/ChartsWidget2Recycler'

import { KTCard } from '../../../_metronic/helpers'

import { MixedWidget16 } from './Mix16'

import { ChartsWidget9 } from '../../../_metronic/partials/widgets/charts/ChartsWidget9'
import { ChartsWidget9C1 } from '../../../_metronic/partials/widgets/charts/ChartsWidget9C1'
import { ChartsWidget9C2 } from '../../../_metronic/partials/widgets/charts/ChartsWidget9C2'
import { ChartsWidget9C3 } from '../../../_metronic/partials/widgets/charts/ChartsWidget9C3'

import MapComponent from '../../modules/apps/data-administration/data-admininstration-list/Map'
import { useQuery } from 'react-query'
import { getUserById } from '../../modules/apps/data-administration/data-admininstration-list/core/_requests'

import { useAuth } from '../../modules/auth'
import TasksDashboard from './TasksDashboard'
import TasksDashboard1 from './TasksDashboard1'
import { MixedWidget11 } from './MixedWidget11'
// recycler widgets imports starts here
import { CardsWidget20 } from '../../../_metronic/partials/widgets'

import { CardsWidget20Copy } from '../../../_metronic/partials/widgets/_new/cards/CardsWidget20Copy'

// import { CardsWidget20Copy } from '../../../_metronic/partials/widgets/_new/cards/CardsWidget20Copy'
// import { ChartsWidget1 } from '../../../_metronic/partials/widgets'
import { CardsWidget7 } from '../../../_metronic/partials/widgets'
import { CardsWidget7C1 } from '../../../_metronic/partials/widgets/_new/cards/CardsWidget7C1'
import { CardsWidget7C2 } from '../../../_metronic/partials/widgets/_new/cards/CardsWidget7C2'
import { CardsWidget17 } from '../../../_metronic/partials/widgets'
import { CardsWidget17Copy } from '../../../_metronic/partials/widgets/_new/cards/CardsWidget17Copy'
import { ListsWidget26 } from '../../../_metronic/partials/widgets'
import { EngageWidget10 } from '../../../_metronic/partials/widgets'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { FeedsWidget6 } from '../../../_metronic/partials/widgets'
// import StatsWidget from '../../../_metronic/partials/widgets/tables/StatsWidget'

// recycler widgets imports ends here







const DashboardPage: FC = () => {



  // const { data = {} } = useQuery(`admin/dashboard`, () => getUserById('', 'admin/dashboard'), {
  //   cacheTime: 0,
  //   onError: (err) => {
  //     console.warn(err)
  //   },
  // })


  const { currentUser } = useAuth() as { currentUser: any };


  // const { data: analyticsData = {} } = useQuery(
  //   `admin/pickupPoints/analytics`,
  //   () => getUserById('', 'admin/pickupPoints/analytics'),
  //   {
  //     cacheTime: 0,
  //     onError: (err) => {
  //       console.warn(err)
  //     },
  //   }
  // )



  // const { data: recyclerData = {} } = useQuery(
  //   `recyclerAnalytics`,
  //   () => getUserById('', 'recyclerAnalytics'),
  //   {
  //     cacheTime: 0,
  //     onError: (err) => {
  //       console.warn(err)
  //     },
  //   }
  // )





  const { data: recyclerData = {} } = useQuery(
    `recyclerAnalytics`,
    () => getUserById('', 'recyclerAnalytics'),
    {
      cacheTime: 0,
      // Only execute the query if userType is RECYCLER
      enabled: currentUser.userType === 'RECYCLER',
      onError: (err) => {
        console.warn(err)
      },
    }
  )



  // const { data: dashboard = {} } = useQuery(
  //   `dashboard/analytics`,
  //   () => getUserById('', 'dashboard/analytics'),
  //   {
  //     cacheTime: 0,
  //     enabled: currentUser.userType === 'SMART_CENTRE',
  //     onSuccess: (data) => {
  //       if (data?.[0]) {
  //         setDaywisePurchaseData(transformChartData(data[0].daywiseApprovedPurchase))
  //         setDaywiseSaleData(transformChartData(data[0].daywiseApprovedSale))
  //       }
  //     },
  //     onError: (err) => {
  //       console.warn(err)
  //     },
  //   }
  // )


  const { data: dashboard = {} } = useQuery(
    `dashboard/analytics`,
    () => getUserById('', 'dashboard/analytics'),
    {
      cacheTime: 0,
      enabled: currentUser.userType === 'SMART_CENTRE',
      onSuccess: (data) => {
        console.log('Dashboard data received:', data)
        if (data?.[0]) {
          console.log('daywiseApprovedPurchase:', data[0].daywiseApprovedPurchase)
          console.log('daywiseApprovedSale:', data[0].daywiseApprovedSale)

          const purchaseData = transformChartData(data[0].daywiseApprovedPurchase)
          const saleData = transformChartData(data[0].daywiseApprovedSale)
          const dispatch = transformChartData(data[0].daywiseDispatched)

          console.log('Transformed purchase:', purchaseData)
          console.log('Transformed sale:', saleData)

          setDaywisePurchaseData(purchaseData)
          setDaywiseSaleData(saleData)
          setDaywiseDispatched(dispatch)
        }
      },
      onError: (err) => {
        console.warn('Error:', err)
      },
    }
  )

  console.log("dashboard", dashboard)

  // console.log("dashboard", dashboard?.[0]?.totalPickupPoints)



  // const { data: recycler = {} } = useQuery(
  //   `users?page=0&size=10&type=RECYCLER&status=ACTIVE`,
  //   () => getUserById('', 'users?page=0&size=10&type=RECYCLER&status=ACTIVE'),
  //   {
  //     cacheTime: 0,
  //     enabled: currentUser.userType === 'SMART_CENTRE',
  //     onError: (err) => {
  //       console.warn(err)
  //     },
  //   }
  // )
  // const { data: pickupPoints = {} } = useQuery(
  //   `users?page=0&size=10&type=PICKUP_POINT`,
  //   () => getUserById('', 'users?page=0&size=10&type=PICKUP_POINT'),
  //   {
  //     cacheTime: 0,
  //     enabled: currentUser.userType === 'SMART_CENTRE',
  //     onError: (err) => {
  //       console.warn(err)
  //     },
  //   }
  // )




















  const [daywisePurchaseData, setDaywisePurchaseData] = useState<any>(null)
  const [daywiseSaleData, setDaywiseSaleData] = useState<any>(null)
  const [daywisDispatch, setDaywiseDispatched] = useState<any>(null)


  const transformChartData = (daywiseData: any) => {
    if (!daywiseData) return null

    const dates = Object.keys(daywiseData).sort()
    const series1 = dates.map(date => daywiseData[date][0])
    const series2 = dates.map(date => daywiseData[date][1])

    console.log('Transform result:', { dates, series1, series2 })

    return {
      categories: dates,
      series1: series1,
      series2: series2,
      series3: []
    }
  }


  const [recyclerId, setRecyclerId] = useState('')
  const [recyclerIdPurchaseOrder, setRecyclerIdPurchaseOrder] = useState('');
  const [pickupPointId, setPickupPointId] = useState('')
  const [startDatePO, setStartDatePO] = useState('');
  const [endDatePO, setEndDatePO] = useState('');
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [dispatchData, setDispatchData] = useState<any>(null);
  const [dispatchData2, setDispatchData2] = useState<any>(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  // Fetch recyclers
  // const { data: recyclers = [] } = useQuery(
  //   `users?page=0&size=10&type=RECYCLER&status=ACTIVE`,
  //   () => getUserById('', 'users?page=0&size=10&type=RECYCLER&status=ACTIVE')
  // )
  const { data: recyclers = [] } = useQuery(
    `users?page=0&size=10&type=RECYCLER&status=ACTIVE`,
    () => getUserById('', 'users?page=0&size=10&type=RECYCLER&status=ACTIVE'),
    {
      enabled: dropdownOpen, // This will prevent the query from running until dropdownOpen is true
      cacheTime: 5 * 60 * 1000, // Cache data for 5 minutes
    }
  )

  // Fetch pickup points
  // const { data: pickupPoints = [] } = useQuery(
  //   `users?page=0&size=10&type=PICKUP_POINT`,
  //   () => getUserById('', 'users?page=0&size=10&type=PICKUP_POINT')
  // )
  const { data: pickupPoints = [] } = useQuery(
    `users?page=0&size=10&type=PICKUP_POINT`,
    () => getUserById('', 'users?page=0&size=10&type=PICKUP_POINT&status=ACTIVE'),
    {
      enabled: dropdownOpen,
      cacheTime: 5 * 60 * 1000,
    }
  )

  // Handle apply filter for daily data structure
  const handleApply = () => {
    // Format dates for API (MM/DD/YYYY)
    const formatDate = (date) => {
      if (!date) return '';
      const d = new Date(date);
      return `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`;
    };

    // Build query params
    let params = new URLSearchParams();
    params.append('page', '0');
    params.append('size', '10');

    if (recyclerId) params.append('recyclerId', recyclerId);
    if (pickupPointId) params.append('pickupPointId', pickupPointId);
    if (startDate) params.append('startDate', formatDate(startDate));
    if (endDate) params.append('endDate', formatDate(endDate));

    // Build the query string
    const queryString = params.toString();

    // Set loading state if desired
    // setIsLoading(true);

    // Make the API call
    getUserById('', `dispatchAnalytics?${queryString}`)
      .then(response => {
        console.log('API response:', response);

        // Set the data directly to state - no type conversion needed
        setDispatchData(response);
      })
      .catch(error => {
        console.error('API error:', error);
        // Clear data on error
        setDispatchData(null);
        // You could show an error message here
      })
      .finally(() => {
        // Clear loading state if used
        // setIsLoading(false);
      });

    console.log('Making API call with params:', queryString);
  };
  const handleApply2 = () => {
    // Format dates for API (MM/DD/YYYY)
    const formatDate = (date) => {
      if (!date) return '';
      const d = new Date(date);
      return `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`;
    };

    // Build query params
    let params = new URLSearchParams();
    params.append('page', '0');
    params.append('size', '10');

    // Use the correct state variables for Purchase Order section
    if (recyclerIdPurchaseOrder) params.append('recyclerId', recyclerIdPurchaseOrder);
    if (startDatePO) params.append('startDate', formatDate(startDatePO));
    if (endDatePO) params.append('endDate', formatDate(endDatePO));

    const queryString = params.toString();

    getUserById('', `recyclerDispatchAnalytics?${queryString}`)
      .then(response => {
        console.log('API response:', response);
        setDispatchData2(response); // Note: Using dispatchData2 instead of dispatchData
      })
      .catch(error => {
        console.error('API error:', error);
        setDispatchData2(null);
      });

    console.log('Making API call with params:', queryString);
  };


  // Handle reset
  const handleReset = () => {
    setRecyclerId('');
    setPickupPointId('');
    setStartDate('');
    setEndDate('');
    setDispatchData(null); // Clear the chart data
  }
  const handleReset2 = () => {
    setRecyclerIdPurchaseOrder('');
    // setPickupPointId('');
    setStartDatePO('');
    setEndDatePO('');
    setDispatchData2(null); // Clear the chart data
  }









































  const { data: adminData = {} } = useQuery(
    `admin/Analytics`,
    () => getUserById('', 'admin/Analytics'),
    {
      cacheTime: 0,
      enabled: currentUser.userType === 'SMART_CENTRE',
      onError: (err) => {
        console.warn(err)
      },
    }
  )


  console.log("adminData", adminData)



  // const { data: cleanUpData = {} } = useQuery(
  //   `collect/orders?page=1&size=10`,
  //   () => getUserById('', 'collect/orders?page=1&size=10'),
  //   {
  //     cacheTime: 0,
  //     onError: (err) => {
  //       console.warn(err)
  //     },
  //   }
  // )







  // const { data: dispatchData = {} } = useQuery(
  //   `convert/orders?page=1&size=10`,
  //   () => getUserById('', 'convert/orders?page=1&size=10'),
  //   {
  //     cacheTime: 0,
  //     onError: (err) => {
  //       console.warn(err)
  //     },
  //   }
  // )






  // Example usage:
  // Call with a RECYCLER user type
  // callRecyclerAnalytics('RECYCLER').then(data => console.log('Result:', data));

  // Call with a different user type (will not make API call)
  // callRecyclerAnalytics('CONSUMER').then(data => console.log('Result:', data));

  const [leaderBoardXaxisData, setleaderBoardXaxisData] = useState([])
  const [leaderBoardYaxisData, setleaderBoardYaxisData] = useState([])

  // useEffect(() => {
  //   if (analyticsData.length) {
  //     const transformedData: any = []

  //     const properties = Object.keys(analyticsData[0]).filter(
  //       (key) =>
  //         key !== 'pickupPointId' &&
  //         key !== 'pickupPointName' &&
  //         key !== 'pickupPointAddress' &&
  //         key !== 'percentageCapacityDiverted' &&
  //         key !== 'percentageAudited'
  //     )
  //     properties.forEach((property) => {
  //       const dataValues = analyticsData?.map((obj) =>
  //         Array.isArray(obj[property]) ? '' : parseFloat(obj[property]?.toFixed(2))
  //       )
  //       transformedData.push({
  //         name: property,
  //         data: dataValues,
  //       })
  //     })
  //     const collectionPointName = analyticsData.map((obj) => obj.pickupPointName)
  //     setleaderBoardXaxisData(collectionPointName)
  //     setleaderBoardYaxisData(transformedData)
  //   }
  // }, [analyticsData])

  const [mapLocation, setMapLocation] = useState([])


  // const { pickupPoints, collectTrend, productionTrend, suppliedTrend } = data

  // useEffect(() => {
  //   if (pickupPoints) {
  //     const modifyData = pickupPoints.map((x) => {
  //       return {
  //         position: {
  //           lat: x.latitude,
  //           lng: x.longitude,
  //         },
  //         name: x.name,
  //       }
  //     })
  //     setMapLocation(modifyData)
  //   }
  // }, [pickupPoints])

  const mapDate = [
    `${new Date().getFullYear()}-01`,
    `${new Date().getFullYear()}-02`,
    `${new Date().getFullYear()}-03`,
    `${new Date().getFullYear()}-04`,
    `${new Date().getFullYear()}-05`,
    `${new Date().getFullYear()}-06`,
    `${new Date().getFullYear()}-07`,
    `${new Date().getFullYear()}-08`,
    `${new Date().getFullYear()}-09`,
    `${new Date().getFullYear()}-10`,
    `${new Date().getFullYear()}-11`,
    `${new Date().getFullYear()}-12`,
  ]
  const [collectedGraphData, setCollectedGraphData] = useState<any>({})
  const [suppliedGraphData, setSuppliedGraphData] = useState<any>({})
  const [processGraphData, setProcessGraphData] = useState<any>({})

  const updateGraphData = (trendData, setGraphData, graphData) => {
    if (trendData && Object.keys(trendData)?.length > 0) {
      const test = mapDate.map(
        (x) => (trendData[x] && (trendData?.[x] / 1000)?.toFixed(2)) || '0.00'
      )
      setGraphData({ ...graphData, monthValue: test })
    }
  }

  const updateGraphData2 = (trendData, setGraphData, graphData) => {
    if (trendData && Object.keys(trendData)?.length > 0) {
      const label = Object.keys(trendData).map((date) => {
        const [year, month, day] = date.split('-') // Split the date string
        return `${month}-${day}` // Format as "day-month"
      })
      // const data = Object.values(trendData)
      const data = Object.values(trendData)?.map((value: any) => parseFloat(value).toFixed(2))
      setGraphData({ ...graphData, label, data })
    }
  }

  // useEffect(() => {
  //   updateGraphData2(collectTrend, setCollectedGraphData, collectedGraphData)
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [collectTrend])

  // useEffect(() => {
  //   updateGraphData2(productionTrend, setProcessGraphData, processGraphData)
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [productionTrend])

  // useEffect(() => {
  //   updateGraphData2(suppliedTrend, setSuppliedGraphData, suppliedGraphData)
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [suppliedTrend])

  // const numberItems = [
  //   { value: 'collected', name: 'Collected', icon: 'Collected', color: '#0F2F97' },
  //   { value: 'processed', name: 'Processed', icon: 'Processed', color: '#1034A6' },
  //   { value: 'supplied', name: 'Supplied', icon: 'Supplied', color: '#405DB8' },
  //   { value: 'stock', name: 'Stock', icon: 'Stock', color: '#5F77C3' },
  //   {
  //     value: 'collectionPoints',
  //     name: 'Aggregators',
  //     icon: 'Collection Point',
  //     color: '#5F77C3',
  //   },
  //   { value: 'wasteDiverters', name: 'Recyclers', icon: 'Waste Diverters', color: '#405DB8' },
  //   { value: 'lifeImpacted', name: 'Collection Agents', icon: 'Life impacted', color: '#1034A6' },
  //   {
  //     value: 'co2Footprint',
  //     name: 'CO2 footprint avoided*',
  //     icon: 'emission avoided',
  //     color: '#0F2F97',
  //   },
  // ]

  const numberItems = [
    { value: 'collected', name: 'Plastic Collected', icon: 'Collected', color: '#ffffff' },
    {
      value: 'received',
      name: 'Processed By Aggregator',
      icon: 'Production',
      color: '#ffffff',
    },
    {
      value: 'externalSale',
      name: 'Plastic Delivered',
      icon: 'Dispatched',
      color: '#ffffff',
    },
    { value: 'stock', name: 'Aggregator Stock', icon: 'new-stock', color: '#ffffff' },
    {
      value: 'collectionPoints',
      name: 'No of Aggregators',
      icon: 'Customer',
      color: '#ffffff',
    },
    {
      value: 'diversionProductionQuantity',
      name: 'No of Recyclers',
      icon: 'waste diverter',
      color: '#ffffff',
    },
    { value: 'wastage', name: 'Waste Pickers', icon: 'process loss', color: '#ffffff' },
    {
      value: 'processed',
      name: 'Life Impacted',
      icon: 'emission',
      color: '#ffffff',
    },
  ]







  const revenueMaterialWise = adminData?.detailsForFY?.totalRevenueMaterialWise ?? {};

  const revenueChartData = Object.entries(revenueMaterialWise).map(
    ([key, value]) => ({
      name: key,
      quantity: +(value as number).toFixed(3),
    })
  );


  // console.log("revenueChartData", revenueChartData)


  const SaleByMaterial = adminData?.detailsForFY?.totalCollectionMaterialWise ?? {};
  const SaleByMaterialChartData = Object.entries(SaleByMaterial).map(
    ([key, value]) => ({
      name: key,
      quantity: +(value as number).toFixed(3),
    })
  );
  console.log("SaleByMaterialChartData", SaleByMaterialChartData)








  // Get current date and format it as YYYY-MM to match your data structure
  const getCurrentYearMonth = () => {
    const date = new Date();
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
  };
  // Get current month key
  const currentYearMonth = getCurrentYearMonth(); // e.g. "2025-04"
  // Get data for current month (or fallback to empty object if not found)
  const currentMonthData = adminData?.detailsForMonth?.[currentYearMonth] || {};
  // Get totalCollectionMaterialWise for current month
  const RevenueBreakup = currentMonthData.totalRevenueMaterialWise || {};
  // Map the data for the chart
  const RevenueBreakupChartData = Object.entries(RevenueBreakup).map(
    ([key, value]) => ({
      name: key,
      quantity: +(value as number).toFixed(3),
    })
  );

  // console.log("RevenueBreakupChartData", RevenueBreakupChartData)






  const getCurrentYearMonth1 = () => {
    const date = new Date();
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
  };
  // Get current month key
  const currentYearMonth1 = getCurrentYearMonth1(); // e.g. "2025-04"
  // Get data for current month (or fallback to empty object if not found)
  const currentMonthData1 = adminData?.detailsForMonth?.[currentYearMonth1] || {};
  // Get totalCollectionMaterialWise for current month
  const RevenueBreakup1 = currentMonthData1.totalCollectionMaterialWise || {};
  // Map the data for the chart
  const RevenueBreakupChartData1 = Object.entries(RevenueBreakup1).map(
    ([key, value]) => ({
      name: key,
      quantity: +(value as number).toFixed(3),
    })
  );

  console.log("RevenueBreakupChartData1", RevenueBreakupChartData1)


  useEffect(() => {
    console.log('daywisePurchaseData state:', daywisePurchaseData)
    console.log('daywiseSaleData state:', daywiseSaleData)
  }, [daywisePurchaseData, daywiseSaleData])

  /* const numberItems = [
  {name: 'Collected', icon: 'Collected', color: '#ffffff', value: 'collected'},
  {name: 'Processed', icon: 'Production', color: '#ffffff', value: 'processed'},
  {name: 'Dispatched', icon: 'Dispatched', color: '#ffffff', value: 'dispatched'},
  {name: 'Stock', icon: 'Stock', color: '#ffffff', value: 'mrfWaste'},
  {name: 'Customers', icon: 'Customer', color: '#ffffff', value: 'mrfWaste'},
  {name: 'Residuals', icon: 'Residuaks', color: '#ffffff', value: 'recyclingRatio'},
  {name: 'Staff', icon: 'Staff', color: '#ffffff', value: 'resourceRecovery'},
  {name: 'C02 Avoided', icon: 'emission', color: '#ffffff', value: 'coprocessingRatio'},
] */

  return (
    <>
      <div className='row g-xl-4' style={{ marginBottom: '20px' }}>
        {currentUser?.userType === "RECYCLER" && (
          <>
            {/* recycler widgets starts here */}
            <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
              <div className='col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-md-5 mb-xl-10'>
                <CardsWidget20
                  className='h-md-50 mb-5 mb-xl-10'
                  description={"Purchase Orders"}
                  color='#F1416C'
                  data={recyclerData}
                  img={toAbsoluteUrl('/media/patterns/vector-1.png')}
                />
                <CardsWidget7C1
                  className='h-md-50 mb-5 mb-xl-10'
                  description='Total Number of Deliveries'
                  heroesTitle="PFC Heros"
                  icon={false}
                  stats={recyclerData?.yearlyDetails?.totalDispatchOrders}
                  labelColor='dark'
                  textColor='gray-300'
                />
              </div>







              <div className='col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-md-5 mb-xl-10'>
                <CardsWidget17 className="h-md-50 mb-5 mb-xl-10"
                  chartSize={80}                   // Set chart size to 80px
                  chartLine={15}                   // Set the chart line thickness to 15px
                  chartRotate={180}
                  data={recyclerData}           // Set chart rotation to 180 degrees
                />

                {/* <ListsWidget26 className='h-lg-50' /> */}
                <ListsWidget26
                  className='h-lg-50'
                  items={[
                    { description: 'Payment Mode', value: '12,729' },
                    { description: 'Outstanding', value: recyclerData.totalOutstandingTaxes },
                    { description: 'Overdue', value: recyclerData.totalOverdueTaxes }
                  ]}
                />
              </div>
              <div className='col-xxl-6'>
                {/* <EngageWidget10 className='h-md-100' /> */}
                <FeedsWidget6 className='' />
              </div>
            </div>


            <ChartsWidget2Recycler className=''
              title="PO Vs Dispatch"
              series1Name=" No of Deliveries"
              series2Name="Delivered Qty"
              data={recyclerData}
            />



            {/* recycler widgets ends here */}
          </>
        )}
      </div>







      {currentUser?.userType === "SMART_CENTRE" && (
        <>
          <>
            <div className='row g-5 g-xl-10 '>
              <div className='col-xxl-6'>
                <StatsCard
                  totalPickupPoints={dashboard?.[0]?.totalPickupPoints || 0}
                  activePickupPoints={dashboard?.[0]?.activePickupPoints || 0}
                  totalRecyclers={dashboard?.[0]?.totalRecyclers || 0}
                  activeRecyclers={dashboard?.[0]?.activeRecyclers || 0}
                />
              </div>
              <div className='col-xxl-6'>
                {/* <MixedWidget11 className='' /> */}
                <MixedWidget11
                  className='card-xl-stretch mb-5 mb-xl-8'
                  chartColor='primary'
                  chartHeight='200px'
                  data={dashboard?.[0]}
                  title='Monthly Overview'
                  subtitle='Sales, Purchase & dispatch'
                />
              </div>
            </div>


            <div style={{ display: 'flex', justifyContent: 'flex-start', gap: '24px', marginBottom: '30px' }}>
              <div style={{ flex: '0 0 28%' }}>
                <TasksDashboard dashboardData={dashboard} />
              </div>
              <div style={{ flex: '0 0 28%' }}>
                <TasksDashboard1 dashboardData={dashboard} />
              </div>
              <div style={{ flex: '0 0 40%', display: 'flex', flexDirection: 'column', gap: '16px' }}>
                {/* Upper Row - Revenue and Gross Margin */}
                <div style={{ display: 'flex', gap: '16px' }}>
                  {/* Revenue Card */}
                  <div style={{
                    flex: 1,
                    padding: '28px 14px',
                    borderRadius: '6px',
                    boxShadow: '0 1px 2px rgba(0,0,0,0.08)',
                    backgroundColor: '#ffffff',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    minHeight: '190px'
                  }}>
                    <div style={{
                      width: '60px',
                      height: '60px',
                      borderRadius: '50%',
                      backgroundColor: '#c8f0e8',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginBottom: '14px',
                      flexShrink: 0
                    }}>
                      <img src="/Revenue.png" alt="" style={{ width: '34px', height: '34px' }}></img>
                    </div>
                    <div style={{ fontSize: '15px', color: '#333', marginBottom: '8px', lineHeight: '1.3' }}>
                      Revenue
                    </div>
                    <div style={{
                      fontSize: '28px',
                      fontWeight: 700, color: '#000'
                    }}>
                      {Math.round(adminData?.detailsForFY?.totalRevenue)}
                    </div>
                  </div>

                  {/* Gross Margin Card */}
                  <div style={{
                    flex: 1,
                    padding: '28px 14px',
                    borderRadius: '6px',
                    boxShadow: '0 1px 2px rgba(0,0,0,0.08)',
                    backgroundColor: '#ffffff',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    minHeight: '190px'
                  }}>
                    <div style={{
                      width: '60px',
                      height: '60px',
                      borderRadius: '50%',
                      backgroundColor: '#c8f0e8',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginBottom: '14px',
                      flexShrink: 0
                    }}>
                      <img src="/Gross Margin.png" alt="" style={{ width: '34px', height: '34px' }}></img>
                    </div>
                    <div style={{ fontSize: '15px', color: '#333', marginBottom: '8px', lineHeight: '1.3' }}>Gross Margin</div>
                    <div style={{
                      fontSize: '28px',
                      fontWeight: 700, color: '#000'
                    }}>
                      {adminData?.detailsForFY?.grossMargin?.toLocaleString('en-In') || '0.00'}
                    </div>
                  </div>
                </div>

                {/* Lower Row - Gross Margin (%) and Net Margin (%) */}
                <div style={{ display: 'flex', gap: '16px' }}>
                  {/* Gross Margin Percentage Card */}
                  <div style={{
                    flex: 1,
                    padding: '28px 14px',
                    borderRadius: '6px',
                    boxShadow: '0 1px 2px rgba(0,0,0,0.08)',
                    backgroundColor: '#ffffff',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    minHeight: '190px'
                  }}>
                    <div style={{
                      width: '60px',
                      height: '60px',
                      borderRadius: '50%',
                      backgroundColor: '#f7f5c5',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginBottom: '14px',
                      flexShrink: 0
                    }}>
                      <img src="/Gross Margin (2).png" alt="" style={{ width: '34px', height: '34px' }}></img>
                    </div>
                    <div style={{ fontSize: '15px', color: '#333', marginBottom: '8px', lineHeight: '1.3' }}>Gross Margin (%)</div>
                    <div style={{
                      fontSize: '28px',
                      fontWeight: 700, color: '#000'
                    }}>
                      {adminData?.detailsForFY?.grossMarginPercentage === 'NaN' || !adminData?.detailsForFY?.grossMarginPercentage
                        ? '0.00'
                        : parseFloat(adminData?.detailsForFY?.grossMarginPercentage).toLocaleString('en-In')}
                    </div>
                  </div>

                  {/* Net Margin Percentage Card */}
                  <div style={{
                    flex: 1,
                    padding: '28px 14px',
                    borderRadius: '6px',
                    boxShadow: '0 1px 2px rgba(0,0,0,0.08)',
                    backgroundColor: '#ffffff',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    minHeight: '190px'
                  }}>
                    <div style={{
                      width: '60px',
                      height: '60px',
                      borderRadius: '50%',
                      backgroundColor: '#dff5eb',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginBottom: '14px',
                      flexShrink: 0
                    }}>
                      <img src="/Gross Margin (2).png" alt="" style={{ width: '34px', height: '34px' }}></img>
                    </div>
                    <div style={{ fontSize: '15px', color: '#333', marginBottom: '8px', lineHeight: '1.3' }}>Net Margin (%)</div>
                    <div style={{
                      fontSize: '28px',
                      fontWeight: 700, color: '#000'
                    }}>
                      {adminData?.detailsForFY?.netMarginPercentage === 'NaN' || !adminData?.detailsForFY?.netMarginPercentage
                        ? '0.00'
                        : parseFloat(adminData?.detailsForFY?.netMarginPercentage).toLocaleString('en-In')}
                    </div>
                  </div>
                </div>
              </div>
            </div>


            {currentUser?.userType === "SMART_CENTRE" && (
              <>



                {daywisePurchaseData && (
                  <div className='row mb-8'>
                    <div className='col-12'>
                      <MixedWidget16
                        className='card-xl-stretch mb-5 mb-xl-8'
                        chartColor='primary'
                        chartHeight='300px'
                        data={daywisDispatch}
                        title='Day-wise Approved Dispatch'
                        subtitle=''
                        amount='Total'
                      />
                    </div>
                  </div>
                )}



                {daywisePurchaseData && (
                  <div className='row mb-8'>
                    <div className='col-12'>
                      <MixedWidget16
                        className='card-xl-stretch mb-5 mb-xl-8'
                        chartColor='primary'
                        chartHeight='300px'
                        data={daywisePurchaseData}
                        title='Day-wise Approved Purchase'
                        subtitle=''
                        amount='Total'
                      />
                    </div>
                  </div>
                )}

                {daywiseSaleData && (
                  <div className='row mb-8'>
                    <div className='col-12'>
                      <MixedWidget16
                        className='card-xl-stretch mb-5 mb-xl-8'
                        chartColor='success'
                        chartHeight='300px'
                        data={daywiseSaleData}
                        title='Day-wise Approved Sale'
                        subtitle=''
                        amount='Total'
                      />
                    </div>
                  </div>
                )}
              </>

            )}


            <div style={{ display: 'flex', gap: '16px', marginBottom: '30px' }}>
              <div style={{ flex: 1 }}>
                <ChartsWidget9
                  className="mb-5"
                  label="Revenue Breakup (FY)"
                  data={
                    revenueChartData
                  }
                />
              </div>

              <div style={{ flex: 1 }}>
                {/* <ChartsWidget9C1
                  className="mb-5"
                  label=""
                  data={inventory.characteristicQuantityPairs}
                /> */}
                <ChartsWidget9C1
                  className="mb-5"
                  label="Sale by Material (FY)"
                  data={SaleByMaterialChartData}
                />
              </div>



              <div style={{ flex: 1 }}>
                <ChartsWidget9C2
                  className="mb-5"
                  label="Revenue Breakup (Month)"
                  data={RevenueBreakupChartData}
                />
              </div>

              <div style={{ flex: 1 }}>
                <ChartsWidget9C3
                  className="mb-5"
                  label="Sale by Material (Month)"
                  data={RevenueBreakupChartData1}
                />
              </div>
            </div>







            <div className="row g-5 g-xl-8 mb-xl-5 mb-5 mb-xl-8">
              <div className="col-xl-6">
                <ChartsWidget2Copy className="mb-xl-0"
                  title="Volume (Kg)"
                  series1Name="Volume"
                  data={adminData}
                  chartMode="volume"
                />
              </div>
              <div className="col-xl-6">
                <ChartsWidget2Copy className="mb-xl-0"
                  title="Revenue (INR)"
                  series2Name="Revenue"
                  data={adminData}
                  chartMode="revenue"
                />
              </div>
            </div>


            <div style={{ margin: "40px 0" }}></div>


            <ChartsWidget2
              className=""
              title="Margin"
              series1Name="% Gross Margin"
              series2Name="Gross Margin"
              data={adminData}
            />

            <div style={{ margin: "40px 0" }}></div>
















            {/* recycler widgets ends here */}




            <div className="card mb-5">
              <div className="card-header">
                <p className="card-title" style={{ fontWeight: "bold" }}>Listing vs Dispatch</p>
              </div>
              <div className="card-body">
                <div className="row mb-4">


                  {/* Pickup Point Dropdown */}
                  <div className="col-md-3 mb-3">
                    <label className="form-label">Supply Partner</label>
                    <select
                      className="form-select"
                      value={pickupPointId}
                      onChange={(e) => setPickupPointId(e.target.value)}
                      onFocus={() => setDropdownOpen(true)}
                    >
                      <option value="">Supply Partner</option>
                      {Array.isArray(pickupPoints) && (pickupPoints as any[]).map(item => (
                        <option key={item.id} value={item.id}>
                          {item.companyDetails?.name || 'Unnamed Pickup Point'}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Recycler Dropdown */}
                  <div className="col-md-3 mb-3">
                    <label className="form-label">Recycler</label>
                    <select
                      className="form-select"
                      value={recyclerId}
                      onChange={(e) => setRecyclerId(e.target.value)}
                      onFocus={() => setDropdownOpen(true)}
                    >
                      <option value="">Select Recycler</option>
                      {Array.isArray(recyclers) && recyclers.map((item: any) => (
                        <option key={item.id} value={item.id}>
                          {item.companyDetails?.name || 'Unnamed Recycler'}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Start Date */}
                  <div className="col-md-3 mb-3">
                    <label className="form-label">Start Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                    />
                  </div>

                  {/* End Date */}
                  <div className="col-md-3 mb-3">
                    <label className="form-label">End Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                    />
                  </div>
                </div>

                {/* Buttons */}
                <div className="d-flex justify-content-end">
                  <button
                    className="btn btn-light me-2"
                    onClick={handleReset}
                  >
                    Reset
                  </button>
                  <button
                    className="btn btn-primary"
                    onClick={handleApply}
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
            {dispatchData && (

              <div style={{ display: 'flex', justifyContent: 'space-between', margin: '10px 0' }}>
                {/* <div style={{
                  margin: '10px',
                  textAlign: 'center',
                  fontSize: '16px',
                  fontWeight: '600',
                  padding: '16px',
                  borderRadius: '8px',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  flex: 1,
                  backgroundColor: '#ffffff'
                }}>
                  <div><strong>Listed</strong></div>
                  <div>{dispatchData?.[0].saleOrderListing}</div>
                </div> */}



                <div style={{
                  margin: '10px',
                  padding: '16px',
                  borderRadius: '8px',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  backgroundColor: '#ffffff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'start', // ✅ center horizontally
                  flex: 1
                }}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',        // ✅ center vertically inside this row
                    justifyContent: 'center'
                  }}>
                    <div style={{
                      width: '48px',
                      height: '48px',
                      borderRadius: '50%',
                      backgroundColor: '#bfd7ed',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: '16px',
                      fontSize: '20px',
                      fontWeight: 'bold',
                      color: '#1a1a1a'
                    }}>
                      <img src="/media/svg/files/Listed Stock.png" alt="" style={{ width: '27px', height: '27px' }}></img>
                    </div>

                    <div style={{ textAlign: 'left' }}>
                      <div style={{ fontSize: '16px', fontWeight: '400' }}>Listed</div>
                      <div style={{ fontSize: '24px', fontWeight: '700' }}>
                        {dispatchData?.[0].saleOrderListing}
                      </div>
                    </div>
                  </div>
                </div>





                {/* <div style={{
                  // flex: 1,
                  // padding: '20px',
                  margin: '10px',
                  // backgroundColor: '#f2f2f2',
                  // border: '1px solid #ccc',
                  // borderRadius: '8px',
                  textAlign: 'center',
                  fontSize: '16px',
                  fontWeight: '600',

                  padding: '16px',
                  borderRadius: '8px',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  // maxWidth: '300px',
                  flex: 1,
                  backgroundColor: '#ffffff'
                }}>
                  <div><strong>Approved Listing</strong></div>
                  <div>{dispatchData?.[0].saleOrderConfirmation}</div>
                </div> */}


                <div style={{
                  margin: '10px',
                  padding: '16px',
                  borderRadius: '8px',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  backgroundColor: '#ffffff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'start', // ✅ center horizontally
                  flex: 1
                }}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',        // ✅ center vertically inside this row
                    justifyContent: 'center'
                  }}>
                    <div style={{
                      width: '48px',
                      height: '48px',
                      borderRadius: '50%',
                      backgroundColor: '#bfd7ed',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: '16px',
                      fontSize: '20px',
                      fontWeight: 'bold',
                      color: '#1a1a1a'
                    }}>
                      <img src="/media/svg/files/Approved listing 1.png" alt="" style={{ width: '27px', height: '27px' }}></img>
                    </div>

                    <div style={{ textAlign: 'left' }}>
                      <div style={{ fontSize: '16px', fontWeight: '400' }}>Approved Listing</div>
                      <div style={{ fontSize: '24px', fontWeight: '700' }}>
                        {dispatchData?.[0].saleOrderConfirmation}
                      </div>
                    </div>
                  </div>
                </div>





                {/* <div style={{
                  // flex: 1,
                  // padding: '20px',
                  margin: '10px',
                  // backgroundColor: '#f2f2f2',
                  // border: '1px solid #ccc',
                  // borderRadius: '8px',
                  textAlign: 'center',
                  fontSize: '16px',
                  fontWeight: '600',

                  padding: '16px',
                  borderRadius: '8px',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  // maxWidth: '300px',
                  flex: 1,
                  backgroundColor: '#ffffff'
                }}>
                  <div><strong>No of Dispatch</strong></div>
                  <div>{dispatchData?.[0].totalDispatchOrders}</div>
                </div> */}

                <div style={{
                  margin: '10px',
                  padding: '16px',
                  borderRadius: '8px',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  backgroundColor: '#ffffff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'start', // ✅ center horizontally
                  flex: 1
                }}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',        // ✅ center vertically inside this row
                    justifyContent: 'center'
                  }}>
                    <div style={{
                      width: '48px',
                      height: '48px',
                      borderRadius: '50%',
                      backgroundColor: '#bfd7ed',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: '16px',
                      fontSize: '20px',
                      fontWeight: 'bold',
                      color: '#1a1a1a'
                    }}>
                      {/* <img src="/media/svg/files/Approved listing 1.png" alt="" style={{ width: '27px', height: '27px' }}></img> */}


                      <img src="/media/svg/files/Delivery Order.png" alt="" style={{ width: '27px', height: '27px' }}></img>

                    </div>

                    <div style={{ textAlign: 'left' }}>
                      <div style={{ fontSize: '16px', fontWeight: '400' }}>No of Dispatch</div>
                      <div style={{ fontSize: '24px', fontWeight: '700' }}>
                        {dispatchData?.[0].totalDispatchOrders}
                      </div>
                    </div>
                  </div>
                </div>





                {/* <div style={{
                  // flex: 1,
                  // padding: '20px',
                  margin: '10px',
                  // backgroundColor: '#f2f2f2',
                  // border: '1px solid #ccc',
                  // borderRadius: '8px',
                  textAlign: 'center',
                  fontSize: '16px',
                  fontWeight: '600',

                  padding: '16px',
                  borderRadius: '8px',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  // maxWidth: '300px',
                  flex: 1,
                  backgroundColor: '#ffffff'
                }}>
                  <div><strong>Dispatch Quantity</strong></div>
                  <div>{dispatchData?.[0].totalDispatchedQuantity}</div>
                </div> */}

                <div style={{
                  margin: '10px',
                  padding: '16px',
                  borderRadius: '8px',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  backgroundColor: '#ffffff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'start', // ✅ center horizontally
                  flex: 1
                }}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',        // ✅ center vertically inside this row
                    justifyContent: 'center'
                  }}>
                    <div style={{
                      width: '48px',
                      height: '48px',
                      borderRadius: '50%',
                      backgroundColor: '#bfd7ed',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: '16px',
                      fontSize: '20px',
                      fontWeight: 'bold',
                      color: '#1a1a1a'
                    }}>
                      {/* <img src="/media/svg/files/Approved listing 1.png" alt="" style={{ width: '27px', height: '27px' }}></img> */}
                      <img src="/media/svg/files/Delivery Order.png" alt="" style={{ width: '27px', height: '27px' }}></img>
                    </div>

                    <div style={{ textAlign: 'left' }}>
                      <div style={{ fontSize: '16px', fontWeight: '400' }}>Dispatch Quantity</div>
                      <div style={{ fontSize: '24px', fontWeight: '700' }}>
                        {dispatchData?.[0].totalDispatchedQuantity}
                      </div>
                    </div>
                  </div>
                </div>



              </div>
            )}
            {dispatchData && (
              <div className='row mb-8'>
                <div className='col-12'>
                  <ChartsWidget3
                    className='card-xl-stretch mb-xl-8'
                    chartData={dispatchData} // This is where I'm passing the data
                  />
                </div>
              </div>
            )}








            {/* Purchase order vs dispatch */}
            <div className="card mb-5">
              <div className="card-header">
                <p className="card-title" style={{ fontWeight: "bold" }}>Purchase order vs Dispatch</p>
              </div>
              <div className="card-body">
                <div className="row mb-4 align-items-end">
                  {/* Recycler Dropdown */}
                  <div className="col-md-3 mb-3">
                    <label className="form-label">Recycler</label>
                    <select
                      className="form-select"
                      value={recyclerIdPurchaseOrder}
                      onChange={(e) => setRecyclerIdPurchaseOrder(e.target.value)}
                      onFocus={() => setDropdownOpen(true)}
                    >
                      <option value="">Select Recycler</option>
                      {Array.isArray(recyclers) &&
                        recyclers.map((item: any) => (
                          <option key={item.id} value={item.id}>
                            {item.companyDetails?.name || 'Unnamed Recycler'}
                          </option>
                        ))}
                    </select>
                  </div>

                  {/* Start Date */}
                  <div className="col-md-3 mb-3">
                    <label className="form-label">Start Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={startDatePO}
                      onChange={(e) => setStartDatePO(e.target.value)}
                    />
                  </div>

                  {/* End Date */}
                  <div className="col-md-3 mb-3">
                    <label className="form-label">End Date</label>
                    <input
                      type="date"
                      className="form-control"
                      value={endDatePO}
                      onChange={(e) => setEndDatePO(e.target.value)}
                    />
                  </div>

                  {/* Buttons */}
                  <div className="col-md-3 mb-3 d-flex justify-content-end gap-2">
                    <button className="btn btn-light me-2" onClick={handleReset2}>
                      Reset
                    </button>
                    <button className="btn btn-primary" onClick={handleApply2}>
                      Apply
                    </button>
                  </div>
                </div>
              </div>


            </div>
            {dispatchData2 && (

              <div style={{ display: 'flex', justifyContent: 'space-between', margin: '10px 0' }}>
                {/* <div style={{
                  // flex: 1,
                  // padding: '20px',
                  margin: '10px',
                  // backgroundColor: '#f2f2f2',
                  // border: '1px solid #ccc',
                  // borderRadius: '8px',
                  textAlign: 'center',
                  fontSize: '16px',
                  fontWeight: '600',

                  padding: '16px',
                  borderRadius: '8px',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  // maxWidth: '300px',
                  flex: 1,
                  backgroundColor: '#ffffff'
                }}>
                  <div><strong>Listed</strong></div>
                  <div>{dispatchData2?.[0].saleOrderListing}</div>
                </div> */}

                <div style={{
                  margin: '10px',
                  padding: '16px',
                  borderRadius: '8px',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  backgroundColor: '#ffffff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'start', // ✅ center horizontally
                  flex: 1
                }}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',        // ✅ center vertically inside this row
                    justifyContent: 'center'
                  }}>
                    <div style={{
                      width: '48px',
                      height: '48px',
                      borderRadius: '50%',
                      backgroundColor: '#bfd7ed',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: '16px',
                      fontSize: '20px',
                      fontWeight: 'bold',
                      color: '#1a1a1a'
                    }}>
                      <img src="/media/svg/files/Listed Stock.png" alt="" style={{ width: '27px', height: '27px' }}></img>
                    </div>

                    <div style={{ textAlign: 'left' }}>
                      <div style={{ fontSize: '16px', fontWeight: '400' }}>Purchase Request</div>
                      <div style={{ fontSize: '24px', fontWeight: '700' }}>
                        {dispatchData2?.[0].purchaseOrderListing}
                      </div>
                    </div>
                  </div>
                </div>



                {/* <div style={{
                  // flex: 1,
                  // padding: '20px',
                  margin: '10px',
                  // backgroundColor: '#f2f2f2',
                  // border: '1px solid #ccc',
                  // borderRadius: '8px',
                  textAlign: 'center',
                  fontSize: '16px',
                  fontWeight: '600',

                  padding: '16px',
                  borderRadius: '8px',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  // maxWidth: '300px',
                  flex: 1,
                  backgroundColor: '#ffffff'
                }}>
                  <div><strong>Approved Listing</strong></div>
                  <div>{dispatchData2?.[0].saleOrderConfirmation}</div>
                </div> */}

                <div style={{
                  margin: '10px',
                  padding: '16px',
                  borderRadius: '8px',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  backgroundColor: '#ffffff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'start', // ✅ center horizontally
                  flex: 1
                }}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',        // ✅ center vertically inside this row
                    justifyContent: 'center'
                  }}>
                    <div style={{
                      width: '48px',
                      height: '48px',
                      borderRadius: '50%',
                      backgroundColor: '#bfd7ed',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: '16px',
                      fontSize: '20px',
                      fontWeight: 'bold',
                      color: '#1a1a1a'
                    }}>
                      <img src="/media/svg/files/Approved listing 1.png" alt="" style={{ width: '27px', height: '27px' }}></img>
                    </div>

                    <div style={{ textAlign: 'left' }}>
                      <div style={{ fontSize: '16px', fontWeight: '400' }}>Purchase Order</div>
                      <div style={{ fontSize: '24px', fontWeight: '700' }}>
                        {dispatchData2?.[0].purchaseOrderConfirmation}
                      </div>
                    </div>
                  </div>
                </div>



                {/* <div style={{
                  // flex: 1,
                  // padding: '20px',
                  margin: '10px',
                  // backgroundColor: '#f2f2f2',
                  // border: '1px solid #ccc',
                  // borderRadius: '8px',
                  textAlign: 'center',
                  fontSize: '16px',
                  fontWeight: '600',

                  padding: '16px',
                  borderRadius: '8px',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  // maxWidth: '300px',
                  flex: 1,
                  backgroundColor: '#ffffff'
                }}>
                  <div><strong>No of Dispatch</strong></div>
                  <div>{dispatchData2?.[0].totalDispatchOrders}</div>
                </div> */}
                <div style={{
                  margin: '10px',
                  padding: '16px',
                  borderRadius: '8px',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  backgroundColor: '#ffffff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'start', // ✅ center horizontally
                  flex: 1
                }}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',        // ✅ center vertically inside this row
                    justifyContent: 'center'
                  }}>
                    <div style={{
                      width: '48px',
                      height: '48px',
                      borderRadius: '50%',
                      backgroundColor: '#bfd7ed',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: '16px',
                      fontSize: '20px',
                      fontWeight: 'bold',
                      color: '#1a1a1a'
                    }}>
                      {/* <img src="/media/svg/files/Approved listing 1.png" alt="" style={{ width: '27px', height: '27px' }}></img> */}


                      <img src="/media/svg/files/Delivery Order.png" alt="" style={{ width: '27px', height: '27px' }}></img>

                    </div>

                    <div style={{ textAlign: 'left' }}>
                      <div style={{ fontSize: '16px', fontWeight: '400' }}>No of Dispatch</div>
                      <div style={{ fontSize: '24px', fontWeight: '700' }}>
                        {dispatchData2?.[0].totalDispatchOrders}
                      </div>
                    </div>
                  </div>
                </div>



                {/* <div style={{
                  // flex: 1,
                  // padding: '20px',
                  margin: '10px',
                  // backgroundColor: '#f2f2f2',
                  // border: '1px solid #ccc',
                  // borderRadius: '8px',
                  textAlign: 'center',
                  fontSize: '16px',
                  fontWeight: '600',

                  padding: '16px',
                  borderRadius: '8px',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  // maxWidth: '300px',
                  flex: 1,
                  backgroundColor: '#ffffff'
                }}>
                  <div><strong>Dispatch Quantity</strong></div>
                  <div>{dispatchData2?.[0].totalDispatchedQuantity}</div>
                </div> */}

                <div style={{
                  margin: '10px',
                  padding: '16px',
                  borderRadius: '8px',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                  backgroundColor: '#ffffff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'start', // ✅ center horizontally
                  flex: 1
                }}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',        // ✅ center vertically inside this row
                    justifyContent: 'center'
                  }}>
                    <div style={{
                      width: '48px',
                      height: '48px',
                      borderRadius: '50%',
                      backgroundColor: '#bfd7ed',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: '16px',
                      fontSize: '20px',
                      fontWeight: 'bold',
                      color: '#1a1a1a'
                    }}>
                      {/* <img src="/media/svg/files/Approved listing 1.png" alt="" style={{ width: '27px', height: '27px' }}></img> */}
                      <img src="/media/svg/files/Delivery Order.png" alt="" style={{ width: '27px', height: '27px' }}></img>
                    </div>

                    <div style={{ textAlign: 'left' }}>
                      <div style={{ fontSize: '16px', fontWeight: '400' }}>Dispatch Quantity</div>
                      <div style={{ fontSize: '24px', fontWeight: '700' }}>
                        {dispatchData2?.[0].totalDispatchedQuantity}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {dispatchData2 && (
              <div className='row mb-8'>
                <div className='col-12'>
                  <ChartsWidget3
                    className='card-xl-stretch mb-xl-8'
                    chartData={dispatchData2} // This is where I'm passing the data
                  />
                </div>
              </div>
            )}


          </>





          {/* <div className='row g-xl-4' style={{ marginBottom: '20px' }}>
            {numberItems.map((eachitems, eachIndex) => (
              <div key={eachIndex + 1 + ''} className='col-xl-3'>
                <StatisticsWidget5
                  className='card-xl-stretch mb-xl-8'
                  // svgIcon={`/media/svg/dashboard/co2.png`}
                  img={eachitems.icon}
                  // color={eachitems.color || 'warning'}
                  color={'white'}
                  iconColor='primary'
                  // title={eachitems.value}
                  title={`
             ${data[eachitems.value]?.toFixed(
                    [
                      'collectionPoints',
                      'diversionFacilities',
                      'wasteDiverters',
                      'lifeImpacted',
                      //  'wastage',
                    ].includes(eachitems.value)
                      ? 0
                      : 2
                  ) || ''
                    }
             ${[
                      'collectionPoints',
                      'diversionFacilities',
                      'wasteDiverters',
                      'lifeImpacted',
                      'wastage',
                    ].includes(eachitems.value)
                      ? ''
                      : ' kg'
                    }
           `}
                  // titleColor='primary'
                  description={eachitems.name}
                // descriptionColor='primary'
                />
              </div>
            ))}
          </div> */}

          {/* {(mapLocation.length && (
            <div>
              <MapComponent data={mapLocation || []} />
            </div>
          )) ||
            null} */}
          {/* <div className='row g-3 g-xl-8 mt-2'>
            <div className='col-xl-3'>
              <StatisticsWidget6
                className='card-xl-stretch mb-xl-8'
                color='success'
                title=''
                description='Listed Volume'
                progress={data?.diversionCapacities || ''}
              />
            </div>

            <div className='col-xl-3'>
              <StatisticsWidget6
                className='card-xl-stretch mb-xl-8'
                color='warning'
                title=''
                description='Purchase Request'
                progress={data?.diversionFacilities || ''}
              />
            </div>
            <div className='col-xl-3'>
              <StatisticsWidget6
                className='card-xl-stretch mb-xl-8'
                color='primary'
                title=''
                description='Transit'
                progress={data?.lifeImpacted || ''}
              />
            </div>

            <div className='col-xl-3'>
              <StatisticsWidget6
                className='card-xl-stretch mb-xl-8'
                color='primary'
                title=''
                description='Payment Pending'
                progress={data?.cO2Footprint || ''}
              />
            </div>
          </div> */}
          {/* <div className='row g-5 g-xl-8'>
            <div className='col-xl-4'>
              <ListsWidget2 data={data?.topCustomers || {}} className='card-xl-stretch mb-xl-8' />
            </div>
            <div className='col-xl-4'>
              <ListsWidget6 data={data?.pickupPoints || []} className='card-xl-stretch mb-5 mb-xl-8' />
            </div>
            <div className='col-xl-4'>
              <ListsWidget4
                data={data?.topEndCustomers || {}}
                className='card-xl-stretch mb-xl-8'
                items={5}
              />
            </div>
          </div> */}

          {/* <TablesWidget10 data={cleanUpData} className='mb-5 mb-xl-8' /> */}

          {/* <br />
          <TablesWidget13 data={dispatchData} className='mb-5 mb-xl-8' /> */}

          <div className='row g-2 g-xl-8'>

            {/* <div className=''>
              <ChartsWidget1
                label={collectedGraphData.label}
                data={collectedGraphData?.data}
                title='Material Collected (Kgs)'
                className='card-xl-stretch mb-xl-8'
             
              />
            </div> */}
            {/* <div className=''>
              <ChartsWidget1
                label={processGraphData.label}
                data={processGraphData?.data}
                title='Material Processed (Kgs)'
                className='card-xl-stretch mb-xl-8'
              // subTitle='Highest daily avg community collector'
              />
            </div> */}
          </div>
          {/* <div className=''>
            <ChartsWidget1
              label={suppliedGraphData.label}
              data={suppliedGraphData?.data}
              title='Material Supplied (Kgs)'
              className='card-xl-stretch mb-xl-8'
            // subTitle='Highest daily avg community collector'
            />
          </div> */}
        </>
      )}




    </>
  )
}

const DashboardWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.DASHBOARD' })}</PageTitle>
      <DashboardPage />
    </>
  )
}

export { DashboardWrapper }
